module.exports = __webpack_public_path__ + "static/media/8010.62e70f18.jpg";